import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Tenant\DeleteFileSettingController::destroy
* @see app/Http/Controllers/Tenant/DeleteFileSettingController.php:20
* @route '/user/branches/{branch}/settings/files/{fileName}'
*/
export const destroy = (args: { branch: number | { id: number }, fileName: string | number } | [branch: number | { id: number }, fileName: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/user/branches/{branch}/settings/files/{fileName}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Tenant\DeleteFileSettingController::destroy
* @see app/Http/Controllers/Tenant/DeleteFileSettingController.php:20
* @route '/user/branches/{branch}/settings/files/{fileName}'
*/
destroy.url = (args: { branch: number | { id: number }, fileName: string | number } | [branch: number | { id: number }, fileName: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            branch: args[0],
            fileName: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        branch: typeof args.branch === 'object'
        ? args.branch.id
        : args.branch,
        fileName: args.fileName,
    }

    return destroy.definition.url
            .replace('{branch}', parsedArgs.branch.toString())
            .replace('{fileName}', parsedArgs.fileName.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\DeleteFileSettingController::destroy
* @see app/Http/Controllers/Tenant/DeleteFileSettingController.php:20
* @route '/user/branches/{branch}/settings/files/{fileName}'
*/
destroy.delete = (args: { branch: number | { id: number }, fileName: string | number } | [branch: number | { id: number }, fileName: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const files = {
    destroy: Object.assign(destroy, destroy),
}

export default files